export const selectArchiveData = (state) => state.archive.archiveData;

export const selectReasons = (state) => state.archive.reasons;

export const selectLoading = (state) => state.archive.isLoading;

export const selectError = (state) => state.archive.error;

export const selectCurrentArchiveStat = (state) => state.archive.currentArchiveStat;